export default __webpack_public_path__ + "static/media/vip.4ab4831e.svg";